import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './alert.module.css';

const DeleteCommentWarning: React.FC<{
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}> = ({ open, onClose, onConfirm }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Confirm action
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							Are you sure you want to delete this comment?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button
					variant="outlined"
					size="medium"
					onClick={onClose}
					className={sty.action_button}
				>
					Cancel
				</Button>
				<Button
					variant="contained"
					size="medium"
					onClick={onConfirm}
					className={sty.action_button}
				>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteCommentWarning;
